import { CustomerReviewsSort } from '../../../CustomerRatingsAndReviewsPage/SortSelection/getSortParams';

export const getSortingSelectionDetailValue = (sortedBy: CustomerReviewsSort) => {
  switch (sortedBy) {
    case CustomerReviewsSort.OLDEST: {
      return 'Älteste zuerst';
    }
    case CustomerReviewsSort.BEST: {
      return 'Positivste zuerst';
    }
    case CustomerReviewsSort.WORST: {
      return 'Negativste zuerst';
    }
    case CustomerReviewsSort.NEWEST:
    default: {
      return 'Neueste zuerst';
    }
  }
};
